/**
 * main.js
 *
 * Bootstraps Vuetify and other plugins then mounts the App
 */

// Composables
import { createApp } from 'vue'

// Components
import App from './App.vue'

// --- Telegram WebApp: загружается параллельно рендерингу ---
// Приложение монтируется сразу, не дожидаясь. Когда скрипт загрузится
// (или таймаут 1.5с), приложение сможет использовать его через window.Telegram
window.TelegramReady = loadTelegramWebApp()

function loadTelegramWebApp() {
  // Проверяем, запущены ли мы в Telegram WebView
  if (!/Telegram/i.test(navigator.userAgent)) {
    console.log('Not in Telegram — skipping Telegram WebApp SDK load');
    window.Telegram = { WebApp: { initData: '' } };
    return Promise.resolve(false);
  }

  return new Promise(function(resolve) {
    var script = document.createElement('script');
    script.src = 'https://telegram.org/js/telegram-web-app.js';

    var resolved = false;
    var timeout = setTimeout(function() {
      if (resolved) return;
      resolved = true;
      console.warn('Telegram Web App not available (timeout)');
      if (!window.Telegram) {
        window.Telegram = { WebApp: { initData: '' } };
      }
      resolve(false);
    }, 1500);

    script.onload = function() {
      if (resolved) return;
      resolved = true;
      clearTimeout(timeout);
      console.log('Telegram Web App loaded');
      resolve(true);
    };

    script.onerror = function() {
      if (resolved) return;
      resolved = true;
      clearTimeout(timeout);
      console.warn('Telegram Web App failed to load');
      if (!window.Telegram) {
        window.Telegram = { WebApp: { initData: '' } };
      }
      resolve(false);
    };

    document.head.appendChild(script);
  });
}

// --- Lazy: reCAPTCHA (explicit render для компонентов) ---
window.loadRecaptcha = function() {
  if (window.__recaptchaLoaded) return;
  window.__recaptchaLoaded = true;
  var s = document.createElement('script');
  s.src = 'https://www.google.com/recaptcha/api.js?render=explicit&hl=ru';
  s.async = true;
  s.defer = true;
  document.head.appendChild(s);
};

// --- Lazy: JivoSite (3s после load) ---
window.addEventListener('load', function() {
  setTimeout(function() {
    var s = document.createElement('script');
    s.src = '//code.jivo.ru/widget/dI38xVre8Q';
    s.async = true;
    document.head.appendChild(s);
  }, 3000);
});


// --- Lazy: Matomo (2s после load, не блокирует рендер) ---
window.addEventListener('load', function() {
  setTimeout(function() {
    var _paq = window._paq = window._paq || [];
    _paq.push(['trackPageView']);
    _paq.push(['enableLinkTracking']);
    (function() {
      var u = "//analytics.zonatorga.ru/";
      _paq.push(['setTrackerUrl', u + 'matomo.php']);
      _paq.push(['setSiteId', '1']);
      var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
      g.async = true;
      g.src = u + 'matomo.js';
      s.parentNode.insertBefore(g, s);
    })();
  }, 2000);
});

// --- Монтирование: ждём Telegram (чтобы router.beforeEach успел auth) ---
const initApp = async () => {
  if (window.TelegramReady) {
    await window.TelegramReady;
  }

  const app = createApp(App)

  const { registerPlugins } = await import('@/plugins')
  registerPlugins(app)
  app.mount('#app')
}

initApp().catch(console.error)